module.exports = __webpack_public_path__ + "img/49.18cc8c28.png";